module.exports = __webpack_public_path__ + "static/media/wa.7d772ca2.svg";